import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import FittingLocationMap from './FittingLocationMap'
import ImportValidator from './utilities/ImportValidator'
import { createRoot } from 'react-dom/client'

// Enable accessibility logging in development
if (process.env.NODE_ENV !== 'production') {
    import('@axe-core/react').then(axe => {
        axe.default(React, ReactDOM, 1000)
    })
}

const container = document.getElementsByTagName('FittingLocationMap')[0]

if (!container) {
    console.error('DOM Element does not exist')
} else {
    const searchParams = new URLSearchParams(window.location.search)
    const params = {}
    for (const [key, value] of searchParams.entries()) {
        if (params[key]) {
            if (!Array.isArray(params[key])) {
                params[key] = [params[key]]
            }
            params[key].push(value)
        } else {
            params[key] = value
        }
    }

    const region = ImportValidator.validateString(container.getAttribute('region'), 'global')
    window.globalThis.region = region
    let filters = ImportValidator.validateStringToArray(container.getAttribute('filters'))
    if (params.f) {
        filters = Array.isArray(params.f) ? params.f : ImportValidator.validateStringToArray(params.f)
    }
    const footer = ImportValidator.validateBool(container.getAttribute('footer'), true)
    const radius = ImportValidator.validateInt(params.r ?? container.getAttribute('radius'), 100)
    const language = ImportValidator.validateLanguage(params.language ?? container.getAttribute('language'))
    const hideSort = ImportValidator.validateSort(params.s ?? container.getAttribute('sort')) === 'hide'
    const sort = hideSort ? 'radius' : ImportValidator.validateSort(params.s ?? container.getAttribute('sort'))
    const unit = ImportValidator.validateString(params.u ?? container.getAttribute('unit'), 'MI')
    const styling = ImportValidator.validateStylings(container.getAttribute('styling'))
    const fittingProcessUrl = ImportValidator.validateString(container.getAttribute('fittingprocessurl'), '')
    const scheduleFittingUrl = ImportValidator.validateString(container.getAttribute('schedulefittingurl'), '')
    const defaultLat = ImportValidator.validateNumber(container.getAttribute('lat'), 33.585786)
    const defaultLong = ImportValidator.validateNumber(container.getAttribute('long'), -112.1072315)
    const queryParamLocationSet =
        !isNaN(parseFloat(params.lat)) && !isNaN(parseFloat(params.lng))
            ? {
                  lat: parseFloat(params.lat),
                  lng: parseFloat(params.lng),
              }
            : undefined
    const defaultZoom = ImportValidator.validateNumber(params.z ?? container.getAttribute('zoom'), 9)

    console.log(fittingProcessUrl)

    // import the correct color palette and fonts
    require(`./assets/styles/${styling}/fonts.css`)
    require(`./assets/styles/${styling}/palette.css`)
    const root = createRoot(container)
    root.render(
        <React.StrictMode>
            <FittingLocationMap
                defaultLat={defaultLat}
                defaultLong={defaultLong}
                defaultZoom={defaultZoom}
                unitType={unit}
                language={language}
                queryParamLocationSet={queryParamLocationSet}
                filters={filters}
                footer={footer}
                radius={radius}
                region={region}
                sort={sort}
                hideSort={hideSort}
                styling={styling}
                fittingProcessUrl={fittingProcessUrl}
                scheduleFittingUrl={scheduleFittingUrl}
            />
        </React.StrictMode>
    )
}
